/** Jobs sahifalari lug'ati (ru). */
export default {
  title: "Вакансии",
  subtitle: "{{open}} открыто · {{filled}} заполнено · {{closed}} закрыто",
  newJob: "+ Новая вакансия",
  filters: {
    carrier: "Перевозчик",
    carrierAll: "Перевозчик: все",
    state: "Штат",
    stateAny: "Штат: любой",
    equipment: "Техника",
    equipmentAny: "Техника: любая",
    status: "Статус",
    statusAll: "Статус: все",
    searchPlaceholder: "Поиск вакансии или перевозчика",
    searchAria: "Поиск вакансий",
  },
  empty: {
    filtered: "Нет вакансий по этим фильтрам",
    none: "Открытых вакансий нет",
    manager: "Создайте вакансию для перевозчика, который нанимает.",
    viewer: "Вакансии перевозчиков добавляет ваш менеджер.",
  },
  columns: {
    job: "Вакансия",
    carrier: "Перевозчик",
    states: "Штаты",
    experience: "Опыт",
    pay: "Оплата",
    homeTime: "Время дома",
    equipment: "Техника",
    status: "Статус",
    candidates: "Кандидаты",
  },
  candidates_one: "{{count}} кандидат",
  candidates_few: "{{count}} кандидата",
  candidates_many: "{{count}} кандидатов",
  candidates_other: "{{count}} кандидатов",
  hiredOf: "нанято {{hired}} из {{openings}}",
  pagination: "вакансий",
  detail: {
    notFound: "Вакансия не найдена.",
    posted: "размещена {{date}}",
    carrierStatus: "перевозчик {{status}}",
    openings: "Места:",
    openingsTail_one: "{{count}} кандидат · закроется, когда все места будут заполнены",
    openingsTail_few: "{{count}} кандидата · закроется, когда все места будут заполнены",
    openingsTail_many: "{{count}} кандидатов · закроется, когда все места будут заполнены",
    openingsTail_other: "{{count}} кандидатов · закроется, когда все места будут заполнены",
    notOpen: "Эта вакансия не открыта",
    submitDriver: "Отправить водителя",
    requirements: "Требования",
    cdl: "CDL",
    cdlClass: "Класс {{cls}}",
    experience: "Опыт",
    hiringStates: "Штаты найма",
    mvr: "MVR",
    dui: "DUI / DWI",
    drugTest: "Тест на наркотики",
    endorsements: "Допуски",
    notSpecified: "не указано",
    notRequired: "не требуется",
    paySchedule: "Оплата и график",
    pay: "Оплата",
    homeTime: "Время дома",
    equipment: "Техника",
    signOnBonus: "Бонус при найме",
    notes: "Заметки",
    matchingTitle: "Подходящие водители · позже",
    matchingText: "Автоподбор по штату, технике и опыту (этап 3). Пока используйте «Отправить водителя»: он предупредит, если водитель не соответствует требованиям.",
    contactTitle: "Контакт перевозчика и отправка",
    contactUnavailable: "Данные перевозчика недоступны.",
    recruiter: "Рекрутер",
    phone: "Телефон",
    email: "Email",
    method: "Способ",
    replyTime: "Срок ответа",
    candidatesTitle: "Кандидаты ({{count}})",
    noSubmissions: "Отправок пока нет",
    myCandidates: "Мои кандидаты",
    candidates: "Кандидаты",
    status: "Статус",
    submitted: "Отправлен",
    carrierReply: "Ответ перевозчика",
    hiddenOthers_one: "{{count}} кандидат других рекрутеров (имя скрыто)",
    hiddenOthers_few: "{{count}} кандидата других рекрутеров (имена скрыты)",
    hiddenOthers_many: "{{count}} кандидатов других рекрутеров (имена скрыты)",
    hiddenOthers_other: "{{count}} кандидатов других рекрутеров (имена скрыты)",
    noCandidates: "Кандидатов пока нет. Отправьте водителя в статусе Qualified или Docs.",
    shortBackground: "Проверка",
  },
  submit: {
    title: "Отправить водителя на вакансию",
    searchPlaceholder: "Поиск среди моих водителей...",
    searchAria: "Поиск водителей",
    eligibleHint: "Подходят: Qualified или Docs. Водители, уже отправленные на эту вакансию, не показаны.",
    noMatch: "Подходящих водителей не найдено.",
    moreHint: "Показано {{shown}} из {{total}} — введите имя, чтобы найти остальных.",
    noEligible: "Нет подходящих водителей. Сначала переведите водителя в Qualified или Docs.",
    matches: "соответствует требованиям",
    notePlaceholder: "Заметка для перевозчика (необязательно)",
    withWarnings: "{{name}} отправлен с предупреждениями",
    submitted: "{{name}} отправлен в {{carrier}}",
    failed: "Не удалось отправить водителя.",
  },
  form: {
    chooseCarrier: "Выберите перевозчика.",
    titleRequired: "Укажите название вакансии.",
    saved: "Вакансия сохранена",
    created: "Вакансия создана",
    saveFailed: "Не удалось сохранить вакансию.",
    editTitle: "Редактировать вакансию",
    newTitle: "Новая вакансия",
    carrier: "Перевозчик",
    choose: "Выберите…",
    jobTitle: "Название вакансии",
    titlePlaceholder: "Dry van OTR, TX",
    status: "Статус",
    openings: "Места",
    minExperience: "Мин. опыт (месяцев)",
    cdlClass: "Класс CDL",
    hiringStates: "Штаты найма",
    all48: "Все 48 штатов",
    pickStates: "Выберите штаты или все 48",
    pay: "Оплата",
    payPlaceholder: "$1,400-1,700 / неделя",
    homeTime: "Время дома",
    driverTypes: "Каких водителей берут",
    freight: "Тип грузов",
    drivingType: "Тип работы",
    equipment: "Техника",
    equipmentPlaceholder: "2024 dry van, автомат",
    signOnBonus: "Бонус при найме",
    bonusPlaceholder: "$2,000 через 90 дней",
    posted: "Размещена",
    endorsements: "Требуемые допуски",
    mvr: "MVR",
    mvrPlaceholder: "≤ 2 нарушений ПДД за 3 года",
    dui: "DUI / DWI",
    duiPlaceholder: "нет за последние 10 лет",
    drugTest: "Тест на наркотики",
    drugPlaceholder: "при приёме, волосы + моча",
    notes: "Заметки",
  },
};
